import { render, staticRenderFns } from "./SongPlayer.vue?vue&type=template&id=6b75db8a"
import script from "./SongPlayer.vue?vue&type=script&lang=js"
export * from "./SongPlayer.vue?vue&type=script&lang=js"
import style0 from "./SongPlayer.vue?vue&type=style&index=0&id=6b75db8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports